'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var FaresOptimizerDateChartTransformationService = function FaresOptimizerDateChartTransformationService(MomentService, $filter, FaresOptimizerConstants, faresOptimizerSaveAdjustedFaresService) {
  var CHART_MAX_DAYS = FaresOptimizerConstants.CHART_MAX_DAYS;
  var DATE_TYPES = {
    SEASON: 'season',
    BLACKOUT: 'blackout'
  };
  var SEASON_TYPES = {
    OUTBOUND: 'outbound',
    INBOUND: 'inbound'
  };
  var rmMomentFormat = $filter('rmMomentFormat');
  function getLabel(type, group, index) {
    var prefix = _.capitalize(group) + _.capitalize(type);
    return prefix + (index + 1) + ' ';
  }
  function isSeason(item) {
    return item.type === DATE_TYPES.SEASON;
  }
  function isBlackout(item) {
    return item.type === DATE_TYPES.BLACKOUT;
  }
  function convertToRange(item, type, group) {
    if (item.begin === undefined) {
      item.begin = new Date().toISOString().split('T')[0];
    }
    var itemStartDay = getMomentType(item.begin);
    var itemEndDay = getMomentType(item.end);
    var startDate = itemStartDay;
    var endDate = itemEndDay;
    return {
      group: group,
      type: type,
      customClass: group + ' ' + type,
      begin: startDate,
      end: endDate
    };
  }
  function filterApplicableDates(date, dateRange) {
    return isInRange(date.begin, dateRange.startDay, dateRange.endDay) || isInRange(date.end, dateRange.startDay, dateRange.endDay) || isInRange(dateRange.endDay, date.begin, date.end);
  }
  function getChartApplicableDates(seasons, blackouts, seasonType, dateRange) {
    function filterElapsedDateRanges(date) {
      return filterApplicableDates(date, dateRange);
    }
    var transformedSeasons = _.transform(seasons, function (result, item) {
      result.push(convertToRange(item, DATE_TYPES.SEASON, seasonType));
      return result;
    }, []);
    var applicableDates = _.transform(blackouts, function (result, item) {
      result.push(convertToRange(item, DATE_TYPES.BLACKOUT, seasonType));
      return result;
    }, transformedSeasons);
    return _.filter(applicableDates, filterElapsedDateRanges);
  }
  function getInboundTravelEndData(inboundTravelToDate, endDay) {
    var endDate = _.isNil(inboundTravelToDate) ? rmMomentFormat(endDay + 1, MomentService.DATE_USER_SETTINGS) : inboundTravelToDate;
    endDate = getMomentType(endDate);
    return [{
      inboundTravelEndDate: endDate,
      className: 'inbound-travel-end',
      color: '#e67e29'
    }];
  }
  function getTravelEndData(travelToDate, endDay) {
    var endDate = _.isNil(travelToDate) ? rmMomentFormat(endDay + 1, MomentService.DATE_USER_SETTINGS) : travelToDate;
    endDate = getMomentType(endDate);
    return [{
      travelEndDate: endDate,
      className: 'outbound-travel-end',
      color: '#ac0000'
    }];
  }
  function getUserOrCurrentDates(data, userDates, startField, endField, chartDates) {
    var userOrStartDate = normalizeDateToString(data[startField]);
    var userOrEndDate = normalizeDateToString(data[endField]);
    if ((chartDates.isEffectiveAndUserAdjustedAvailable || chartDates.isDatePickedFromRecomList) && !_.isNil(userDates)) {
      userOrStartDate = normalizeDateToString(userDates.begin);
      userOrEndDate = normalizeDateToString(userDates.end);
    }
    return {
      userOrStartDate: userOrStartDate,
      userOrEndDate: userOrEndDate
    };
  }
  function getRectangleData(data, startField, endField, className, userOrCurrentDates, chartDates) {
    var result = {};
    var startDateFromDateRange = rmMomentFormat(chartDates.dateRange.startDay, MomentService.TYPE.LOCAL_DATE);
    var endDateFromDateRange = rmMomentFormat(chartDates.dateRange.endDay, MomentService.TYPE.LOCAL_DATE);
    var startDate = _.isNil(chartDates[userOrCurrentDates].userOrStartDate) || isPreviousDate(chartDates[userOrCurrentDates].userOrStartDate, chartDates.dateRange.startDay) ? startDateFromDateRange : chartDates[userOrCurrentDates].userOrStartDate;
    var endDate = _.isNil(chartDates[userOrCurrentDates].userOrEndDate) || isAfterDate(chartDates[userOrCurrentDates].userOrEndDate, chartDates.dateRange.endDay) ? endDateFromDateRange : chartDates[userOrCurrentDates].userOrEndDate;
    result[startField] = getMomentType(startDate);
    result[endField] = getMomentType(endDate);
    changeStartDateIfInvalidRange(result, startField, endField);
    result.className = className;
    return [result];
  }
  function changeStartDateIfInvalidRange(result, startField, endField) {
    if (result[startField].isAfter(result[endField])) {
      result[startField] = result[endField];
    }
  }
  function getMomentType(date) {
    return (0, _typeof2["default"])(date) === 'object' ? date : MomentService.of(date, MomentService.TYPE.LOCAL_DATE);
  }
  function isPreviousDate(date1, date2) {
    date1 = getMomentType(date1);
    date2 = getMomentType(date2);
    if (date1 && date2) {
      return date1.isBefore(date2);
    }
    return false;
  }
  function isAfterDate(date1, date2) {
    date1 = getMomentType(date1);
    date2 = getMomentType(date2);
    if (date1 && date2) {
      return date1.isAfter(date2);
    }
    return false;
  }
  function consolidateTicketingDates(data, fieldName) {
    if (isUserAdjustedDatesNotDefined(data, fieldName)) {
      return {
        begin: undefined,
        end: undefined
      };
    }
    return consolidatedDates(data.userAdjustedDates, fieldName);
  }
  function getConsolidatedEndDate(data, fieldName) {
    var travelEndDate;
    _.each(data[fieldName], function (element) {
      if (!travelEndDate || isAfterDate(element.to, travelEndDate)) {
        travelEndDate = element.to;
      }
      if (!travelEndDate || isAfterDate(element.complete, travelEndDate)) {
        travelEndDate = element.complete;
      }
    });
    return travelEndDate;
  }
  function consolidatedDates(data, fieldName) {
    var startDate;
    var endDate;
    _.each(data[fieldName], function (element) {
      if (!startDate || isPreviousDate(element.begin, startDate)) {
        startDate = element.begin;
      }
      if (!endDate || isAfterDate(element.end, endDate)) {
        endDate = element.end;
      }
    });
    return {
      begin: startDate,
      end: endDate
    };
  }
  function isUserAdjustedDatesNotDefined(data, fieldName) {
    return _.isNil(data.userAdjustedDates) || _.isNil(data.userAdjustedDates[fieldName]) || data.userAdjustedDates[fieldName].length === 0;
  }
  function normalizeDateToString(sourceDate) {
    if (MomentService.isMoment(sourceDate)) {
      return sourceDate.toISOString();
    }
    return sourceDate;
  }
  function isInRange(date, start, end) {
    return date.isBetween(start, end, 'day', '[]');
  }
  function getApplicableDatesForTooltip(isAdaptiveMode, applicableDates, dateRange) {
    var seasonIndex = 0;
    var blackoutIndex = 0;
    function updateLabel(item) {
      if (isSeason(item)) {
        item.label = getLabel(item.type, item.group, seasonIndex);
        seasonIndex = seasonIndex + 1;
      }
      if (isBlackout(item)) {
        item.label = getLabel(item.type, item.group, blackoutIndex);
        blackoutIndex = blackoutIndex + 1;
      }
    }
    function filterByDateRange(date) {
      return filterApplicableDates(date, dateRange);
    }
    return _.chain(applicableDates).filter(filterByDateRange).orderBy(['begin']).map(function (item) {
      updateLabel(item);
      var customizedDateRanges = getCustomizedDatesForDisplay(item, isAdaptiveMode);
      return {
        group: item.group,
        label: item.label,
        customClass: item.customClass,
        begin: customizedDateRanges.begin,
        end: customizedDateRanges.end,
        displayBegin: customizedDateRanges.displayBegin,
        displayEnd: customizedDateRanges.displayEnd
      };
    }).value();
  }
  function getCustomizedDatesForDisplay(item, isAdaptiveMode) {
    var begin = rmMomentFormat(item.begin, MomentService.DATE_USER_SETTINGS);
    var end = rmMomentFormat(item.end, MomentService.DATE_USER_SETTINGS);
    var displayBegin = isAdaptiveMode && isBlackout(item) ? item.begin.format(MomentService.FORMAT.DAY_MONTH) : begin;
    var displayEnd = isAdaptiveMode && isBlackout(item) ? item.end.format(MomentService.FORMAT.DAY_MONTH) : end;
    return {
      begin: begin,
      end: end,
      displayBegin: displayBegin,
      displayEnd: displayEnd
    };
  }
  function getCorrectedDateFormat(value) {
    var momentDate = _.isNil(value) ? ' ' : getMomentType(value);
    return rmMomentFormat(momentDate, MomentService.DATE_USER_SETTINGS);
  }
  function getTooltipData(data, chartDates) {
    return {
      firstTicketDate: getCorrectedDateFormat(chartDates.userOrCurrentTicketingDates.userOrStartDate),
      lastTicketDate: getCorrectedDateFormat(chartDates.userOrCurrentTicketingDates.userOrEndDate),
      effectiveDate: getCorrectedDateFormat(chartDates.userOrCurrentEffectiveDates.userOrStartDate),
      discontinueDate: getCorrectedDateFormat(chartDates.userOrCurrentEffectiveDates.userOrEndDate),
      inboundTravelToDate: getCorrectedDateFormat(chartDates.inboundTravelToDate),
      travelToDate: getCorrectedDateFormat(chartDates.travelToDate),
      fbc: data.fbc,
      outboundApplicableDates: getApplicableDatesForTooltip(data.isAdaptiveMode, chartDates.outboundApplicableDates, chartDates.dateRange),
      inboundApplicableDates: getApplicableDatesForTooltip(data.isAdaptiveMode, chartDates.inboundApplicableDates, chartDates.dateRange)
    };
  }
  function getDateRange() {
    var startDay = MomentService.now(MomentService.TYPE.LOCAL_DATE);
    return {
      startDay: startDay,
      endDay: _.cloneDeep(startDay).add(CHART_MAX_DAYS, 'day')
    };
  }
  function getAdjustedDates(data, fieldName, fallbackAdjustedDates, chartDates) {
    if (chartDates.isDisplayOfUserAdjustedDatesNotAllowed) {
      return fallbackAdjustedDates;
    }
    return chartDates.isEffectiveAndUserAdjustedAvailable || chartDates.isDatePickedFromRecomList ? data.userAdjustedDates[fieldName] : _.find(data.groupedRows, function (eachRow) {
      return eachRow.isEntryLevel === true;
    })[fieldName];
  }
  function getApplicableDates(data, chartDates) {
    var applicableDates = [];
    var outboundApplicableDates = getChartApplicableDates(getAdjustedDates(data, 'outboundSeasons', data.outboundSeasons, chartDates), getAdjustedDates(data, 'outboundBlackouts', data.outboundBlackouts, chartDates), SEASON_TYPES.OUTBOUND, chartDates.dateRange);
    var inboundApplicableDates = getChartApplicableDates(getAdjustedDates(data, 'inboundSeasons', data.inboundSeasons, chartDates), getAdjustedDates(data, 'inboundBlackouts', data.inboundBlackouts, chartDates), SEASON_TYPES.INBOUND, chartDates.dateRange);
    applicableDates = applicableDates.concat(inboundApplicableDates);
    applicableDates = applicableDates.concat(outboundApplicableDates);
    chartDates.inboundApplicableDates = inboundApplicableDates;
    chartDates.outboundApplicableDates = outboundApplicableDates;
    chartDates.applicableDates = applicableDates;
  }
  function getTicketingDateRange(data, chartDates) {
    var userTicketingDates = consolidateTicketingDates(data, 'ticketingDates');
    var currentTicketingDate = consolidatedDates(data, 'ticketingDates');
    data.firstTicketDate = currentTicketingDate.begin;
    data.lastTicketDate = currentTicketingDate.end;
    chartDates.userOrCurrentTicketingDates = getUserOrCurrentDates(data, userTicketingDates, 'firstTicketDate', 'lastTicketDate', chartDates);
    chartDates.ticketingDateRange = getRectangleData(data, 'firstTicketDate', 'lastTicketDate', 'ticketing-dates', 'userOrCurrentTicketingDates', chartDates);
  }
  function getEffectiveDateRange(data, chartDates) {
    chartDates.userOrCurrentEffectiveDates = getUserOrCurrentDates(data, undefined, 'effectiveDate', 'discontinueDate', chartDates);
    chartDates.effectiveDateRange = getRectangleData(data, 'effectiveDate', 'discontinueDate', 'effective-dates', 'userOrCurrentEffectiveDates', chartDates);
  }
  function getInboundTravelEndDate(data, endDay, chartDates) {
    if (chartDates.isDisplayOfUserAdjustedDatesNotAllowed || !chartDates.isEffectiveAndUserAdjustedAvailable && !chartDates.isDatePickedFromRecomList) {
      var currentInboundTravelEndDate = getConsolidatedEndDate(data, 'inboundTravelDates');
      chartDates.inboundTravelEndData = getInboundTravelEndData(currentInboundTravelEndDate, endDay);
      chartDates.inboundTravelToDate = currentInboundTravelEndDate;
      return;
    }
    var userInboundTravelEndDate = getConsolidatedEndDate(data.userAdjustedDates, 'inboundTravelDates');
    chartDates.inboundTravelEndData = getInboundTravelEndData(userInboundTravelEndDate, endDay);
    chartDates.inboundTravelToDate = userInboundTravelEndDate;
  }
  function getTravelEndDate(data, endDay, chartDates) {
    if (chartDates.isDisplayOfUserAdjustedDatesNotAllowed || !chartDates.isEffectiveAndUserAdjustedAvailable && !chartDates.isDatePickedFromRecomList) {
      var currentTravelEndDate = getConsolidatedEndDate(data, 'outboundTravelDates');
      chartDates.travelEndData = getTravelEndData(currentTravelEndDate, endDay);
      chartDates.travelToDate = currentTravelEndDate;
      return;
    }
    var userTravelEndDate = getConsolidatedEndDate(data.userAdjustedDates, 'outboundTravelDates');
    chartDates.travelEndData = getTravelEndData(userTravelEndDate, endDay);
    chartDates.travelToDate = userTravelEndDate;
  }
  function isEffective(title) {
    return title.indexOf(FaresOptimizerConstants.EFFECTIVE_FARES_CHART_TITLE) > -1;
  }
  function isPickDateFromRecomList(data) {
    return data.hostLadder && data.hostLadder.alignedWith === FaresOptimizerConstants.COMPETITOR && data.title.indexOf(FaresOptimizerConstants.EFFECTIVE_FARES_CHART_TITLE) > -1;
  }
  function isUserAdjustmentsPresent(data) {
    var userAdjustementsRecord = _.find(data.groupedRows, function (groupedRow) {
      return !_.isNil(groupedRow.userAdjustedDates);
    });
    if (_.isNil(userAdjustementsRecord)) {
      return false;
    }
    var dateTypesToCheck = _.keys(faresOptimizerSaveAdjustedFaresService.getUserAdjustedDatesRequiredFields());
    for (var i = 0; i < dateTypesToCheck.length; i++) {
      if (!isUserAdjustedDatesNotDefined(userAdjustementsRecord, dateTypesToCheck[i])) {
        return true;
      }
    }
    return false;
  }
  function transformData(data, title, chartData) {
    var chartDates = {
      isDatePickedFromRecomList: isPickDateFromRecomList(chartData),
      isDisplayOfUserAdjustedDatesNotAllowed: !isEffective(title),
      isEffectiveAndUserAdjustedAvailable: isEffective(title) && isUserAdjustmentsPresent(data),
      dateRange: getDateRange()
    };
    getApplicableDates(data, chartDates);
    getTicketingDateRange(data, chartDates);
    getEffectiveDateRange(data, chartDates);
    getInboundTravelEndDate(data, chartDates.dateRange.endDay, chartDates);
    getTravelEndDate(data, chartDates.dateRange.endDay, chartDates);
    return {
      applicableDates: chartDates.applicableDates,
      ticketingDateRange: chartDates.ticketingDateRange,
      effectiveDateRange: chartDates.effectiveDateRange,
      tooltipData: getTooltipData(data, chartDates),
      inboundTravelEndData: chartDates.inboundTravelEndData,
      travelEndData: chartDates.travelEndData,
      dateRange: chartDates.dateRange,
      startDayLabel: rmMomentFormat(chartDates.dateRange.startDay, MomentService.DATE_USER_SETTINGS),
      endDayLabel: rmMomentFormat(chartDates.dateRange.endDay, MomentService.DATE_USER_SETTINGS)
    };
  }
  return {
    transformData: transformData
  };
};
FaresOptimizerDateChartTransformationService.$inject = ['MomentService', '$filter', 'FaresOptimizerConstants', 'FaresOptimizerSaveAdjustedFaresService'];
module.exports = FaresOptimizerDateChartTransformationService;